import type { FlattenSimpleInterpolation } from 'styled-components'
import { css } from 'styled-components'

import { createMixin } from '@vfuk/core-mixins'

import type { Animation } from './animations.types'

const fadeIn: Animation = {
  animation: createMixin(
    (): FlattenSimpleInterpolation => css`
      @keyframes fadeIn {
        0% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
      }
    `,
  ) as Animation['animation'],
  config: {
    duration: 150,
  },
}

export default fadeIn
